<app-stages [stages]="stages" currentStage="Inne dane">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="col-12">
      <div class='form-group' *ngIf='"changeOtherData" as controlName'>
        <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            #input
            (change)="form.changeOtherDataChange(input.checked)"
            [formControlName]='controlName'
            type='checkbox'
            [id]='controlName'
            [name]='controlName'>
          <label [for]='controlName'>
            Moje inne dane które uległy zmianie <small>(np. nazwisko, nr telefonu itp.)</small>
          </label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class="col-12">
      <div class='form-group' *ngIf='"changeOtherDataDescription" as controlName'>
        <label [for]='controlName'>
          Inne dane *
        </label>
        <textarea
          rows="4"
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder='Wpisz tu inne dane które uległy zmianie'>
            </textarea>
        <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='application-actions'>
      <button
        routerLink="../adres-do-doreczen"
        type='button'
        class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
      </button>
      <button
        class='btn btn-primary'
        type="submit">
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
